/* Univers Digital 03-10-2026 - chargement differe de la page marketing Apple Watch Ultra 4.
   Le contenu Apple (HTML, CSS, JS, donnees du comparateur) est charge seulement quand le
   visiteur approche de la zone, pour ne pas ralentir l'affichage de la fiche produit.
   Prix Apple fictifs ("A partir de XXX EUR") retires du comparateur.
   03-10 16h30 : produit pas encore disponible -> "Bientot disponible" + boutons Precommander (udt3-au4-body.txt). */
(function () {
  var box = document.getElementById('ud-apple-au4');
  if (!box || !window.fetch) return;
  var B = 'https://cdn.shopify.com/s/files/1/0835/7104/8768/files/';
  var F = ['udt-au4-css.txt', 'udt3-au4-body.txt', 'udt-au4-js.txt', 'udt-au4-compare.txt', 'udt2-au4-compare-content.txt'];
  var V = box.getAttribute('data-v') || '1';
  var LINKS = {
    'apple-watch-ultra-4': '/products/apple-watch-ultra-4-maroc',
    'apple-watch-series-12': '/products/apple-watch-series-12-maroc',
    'apple-watch-se-3': '/collections/apple-watch-se'
  };
  var started = false;
  function get(n) {
    return fetch(B + n + '?ud=' + V).then(function (r) { if (!r.ok) throw new Error(n + ' ' + r.status); return r.text(); });
  }
  function json(id, txt) {
    var s = document.createElement('script');
    s.type = 'application/json'; s.id = id; s.textContent = txt;
    box.appendChild(s);
  }
  function key(id) { return (id || '').replace(/&nbsp;| |\s+/g, '-').replace(/-+/g, '-').toLowerCase(); }
  function fixLinks() {
    var links = box.querySelectorAll('a.compare-button');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], url = LINKS[key(a.id)], c = a.closest('.button-container');
      if (url) { a.setAttribute('href', url); if (c) c.style.visibility = ''; }
      else if (c) { c.style.visibility = 'hidden'; }
    }
  }
  function load() {
    if (started) return; started = true;
    Promise.all(F.map(get)).then(function (t) {
      var st = document.createElement('style'); st.id = 'ud-au4-css'; st.textContent = t[0];
      document.head.appendChild(st);
      box.innerHTML = t[1];
      json('channel-html-compare', t[3]);
      json('channel-html-compare-content', t[4]);
      var s = document.createElement('script'); s.textContent = t[2];
      document.body.appendChild(s);
      try { window.dispatchEvent(new PageTransitionEvent('pageshow', { persisted: false })); }
      catch (e) { var ev = document.createEvent('Event'); ev.initEvent('pageshow', false, false); ev.persisted = false; window.dispatchEvent(ev); }
      fixLinks();
      var root = box.querySelector('.channel-compare');
      if (root && window.MutationObserver) {
        var tm; new MutationObserver(function () { clearTimeout(tm); tm = setTimeout(fixLinks, 50); })
          .observe(root, { childList: true, subtree: true });
      }
      box.classList.add('is-loaded');
    }).catch(function (e) { started = false; box.classList.add('is-error'); if (window.console) console.warn('[UD Apple]', e); });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); }
    }, { rootMargin: '1500px 0px' });
    io.observe(box);
  } else { load(); }
})();
